import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

const ForgetPassword = () => {
  const [formData, setFormData] = useState({
    email: "",
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    setFormData({
      email: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setSuccess("");

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/user/forgot-password`, {
        email: formData.email,
      });

      setSuccess("Password reset link has been sent to your registered email.");
    } catch (err) {
      toast.error(err.response?.data?.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div id="wrapper">
      <section className="signup-section login-section d-flex align-items-center py-5 py-md-0">
        <div className="container signup-container">
          <div className="row">
            {/* Left Side */}
            <div className="col-md-6 text-white d-flex align-items-center pe-md-5">
              <div className="pe-md-5 text-center text-md-start w-100">
                <h1 className="fw-bold mb-4">Forgot your password?</h1>

                <p className="color858c95 ft-18 lh-27 inter">Enter your registered email address and we'll send you a password reset link.</p>
              </div>
            </div>

            {/* Right Side */}

            <div className="col-md-6">
              <div className="form-container mt-md-0 d-flex align-items-center justify-content-center mt-5">
                <div className="w-100">
                  <h2 className="ft-28 fw-bold mb-1 textred">Forgot Password</h2>
                  <p className="color858c95 ft-14 lh-27 inter"> We'll email you instructions to reset your password.</p>

                  {success && <div className="alert alert-success text-center">{success}</div>}

                  <form onSubmit={handleSubmit}>
                    <div className="form-group">
                      <input
                        type="email"
                        className={`form-control ${formData.email ? "has-value" : ""}`}
                        id="email"
                        name="email"
                        placeholder=" "
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />

                      <label htmlFor="email">Email Address</label>
                    </div>

                    <button type="submit" className="btn btn-red ft-15 fw-600 w-100 my-3 py-3" disabled={loading}>
                      {loading ? "Sending Reset Link...." : "Send Reset Link"} <i className="fa-solid fa-arrow-right ms-2"></i>
                    </button>

                    <p className="mt-3 ft-14 lh-24 text-center">
                      Remember your password?
                      <Link to="/login" className="Register-link textred" style={{ marginLeft: "5px" }}>
                        Sign In
                      </Link>
                    </p>
                  </form>
                </div>
              </div>
            </div>
            {/* Right Side End */}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ForgetPassword;
